<template>
	<div>
		<topback title="Buy History" path="back"></topback>
		<md-tab-bar class="nav-tab" v-model="current" :items="items" @change="onTabChange"></md-tab-bar>

		<div class="deposit-history">
			<md-swiper ref="swiper" :autoplay="0" :is-prevent="false" :is-loop="false" :has-dots="false"
				@before-change="onSwiperChange">
				<md-swiper-item>
					<md-notice-bar style="margin-top: 0.75rem;">
						<md-icon slot="left" name="warn"></md-icon>
						If Deposits not arrived 
						<span style="color:red" @click="contact_service">Please contact service</span>
					</md-notice-bar>
					<deposihistorylist method="usdt" v-if="method==='usdt'"></deposihistorylist>
				</md-swiper-item>
				<md-swiper-item>
					<deposihistorylist class="inr-list" method="inr" v-if="method==='inr'"></deposihistorylist>
				</md-swiper-item>
			</md-swiper>
		</div>
	</div>
</template>

<script>
import topback from '@/components/topback'
import pointtext from '@/components/pointtext'
import { Dialog } from 'mand-mobile'
import deposihistorylist from '@/views/recharge/deposihistorylist'


export default {
	name: 'deposithistory',
	components: {
		[topback.name]: topback,
		[pointtext.name]: pointtext,
		deposihistorylist
	},

	data() {
		return {
			current: 0,
			method: 'usdt',
			items: [{ name: 0, label: 'USDT' }, { name: 1, label: 'INR' }],
			first: true
		}
	},
	created() {
		if(this.$route.params.method === 'inr' && this.first) {
			this.first = false;
			let that = this;
			setTimeout(() => {
				that.$refs.swiper.next();
			}, 300);
		}
	},
	methods: {
		onSwiperChange(from, to) {
			this.current = to
			if (this.current === 0) {
				this.method = 'usdt'
			} else {
				this.method = 'inr'
			}
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0;
		},
		onTabChange(item, index) {
			this.$refs.swiper.goto(index)
		},
		contact_service() {
			let that = this;
			Dialog.confirm({
				title: 'Tipp',
				content: 'If you have confirmed the transfer, please wait for up to 20 minutes for blockchain confirmation, if it has not been confirmed for a long time, please contact customer service',
				confirmText: 'Contact Support',
				cancelText: 'Cancel',
				onConfirm: () => {
					that.$router.push('/customerservice');
				},
			})
		}
	}
}

</script>
<style scoped>
.inr-list {
	margin-top: 0.75rem;
}
.nav-tab {
	position: fixed !important;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
    background-color: #f9fafb;
    top: 1rem;
    z-index: 998;
    width: 100%;
}
.deposit-history {
	margin-top: 0.9rem;
}

.deposit-history .md-swiper {
	background: #FFF;
}

.deposit-history .md-swiper .md-swiper-item {
	padding: 20px;
	box-sizing: border-box;
	font-size: 24px;
	line-height: 1.5;
	color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/recharge/deposithistory.vue